<div style="height: 90%; display: flex; flex-direction: column;">
    <div>
        <h6 i18n class="display-6" style="margin-top: 10px; margin-left: 10px;">PRIVACY NOTICE STATEMENT</h6>
        <p style="margin-left: 10px">
            The information you provide through the electronic logbook client application is collected under the 
            authority of the <em>Fisheries Act</em> and the <em>Fishery (General) Regulations</em> for the purpose of administering the 
            commercial fisheries under DFO's jurisdiction. The information may be used for compliance review, 
            program planning or management, reporting, safety or security purposes, audit, evaluation, statistical, 
            research, policy development, administration or enforcement of a law, the detection, prevention, or 
            suppression of crime, and investigative purposes. You have the right to the correction of, access to, and 
            protection of your personal information under the <em>Privacy Act</em> and to file a complaint with the Privacy 
            Commissioner of Canada over DFO's handling of your information. Personal information collected 
            through the e-log application is described in the Personal Information Bank (PIB) <u>DFO PPU 410</u>. For 
            more information, visit Info Source at <a href="https://www.infosource.gc.ca" target="_blank" style="font-weight: bold;">www.infosource.gc.ca</a>.
        </p>

        <h6 i18n class="display-6" style="margin-top: 50px; margin-left: 10px;">HARVESTER ATTESTATION</h6>
        <p style="margin-left: 10px;">
            The information being collected through this electronic logbook is subject to the Access to Information 
            Act (R.S.C., 1985, c. A-1) and the Privacy Act (R.S.C., 1985, c. P-21) and will be treated accordingly.
        </p>   
            
        <p i18n style="margin-top: 20px; margin-left: 10px; font-weight: bold;">By submitting this electronic logbook to DFO, I attest to the following:</p>

        <mat-checkbox i18n [(ngModel)]="declarationChecked" style="padding-top: 10px; margin-bottom: 15px;">
            I declare I am the license holder or substitute operator appointed for the license provided in this 
            electronic logbook. I attest that the information given is true, accurate and complete. I 
            understand that the information I am providing to DFO is being collected as part of license 
            conditions issued under the authority of the Fisheries (General) Regulations (SOR/93-53). I 
            understand that making a false or misleading statement, whether orally or in writing, is a 
            violation of the <em>Fisheries Act</em> (R.S.C., 1985, c. F-14)
        </mat-checkbox>

    </div>

    <div class="row" style="margin-top: auto; display: flex; justify-content: space-around;">
        <div class="col-5">
            <button i18n mat-raised-button class="cancel-button" (click)="dialogRef.close(false)">
                  Cancel
            </button>
                    
        </div>
        <div class="col-5">
            <button i18n mat-raised-button class="confirm-button" type="submit" [ngClass]="declarationChecked ? ['confirm-button'] : ['disabled']" [disabled]="!declarationChecked" (click)="dialogRef.close(true)">
                Confirm
            </button>         
        </div>
    </div>
</div>
